/**
 * Authentication Hook
 * Custom hook that provides access to authentication context throughout the application
 */

import { useContext } from "react";
import AuthContext from "../context/auth-provider";

/**
 * Hook for accessing authentication context
 * Provides access to auth state and methods for managing authentication
 * @returns {Object} Authentication context containing auth state and setAuth function
 */
const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
